import { LOCALES, type Locale } from '@erp/shared';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';


import arAccounts from '../locales/ar/accounts.json';
import arAi from '../locales/ar/ai.json';
import arAiReports from '../locales/ar/aiReports.json';
import arAudit from '../locales/ar/audit.json';
import arAuth from '../locales/ar/auth.json';
import arBrand from '../locales/ar/brand.json';
import arCashback from '../locales/ar/cashback.json';
import arCms from '../locales/ar/cms.json';
import arStories from '../locales/ar/stories.json';
import arCommon from '../locales/ar/common.json';
import arCoupons from '../locales/ar/coupons.json';
import arCrm from '../locales/ar/crm.json';
import arDiscounts from '../locales/ar/discounts.json';
import arCustomFields from '../locales/ar/customFields.json';
import arDocuments from '../locales/ar/documents.json';
import arErrors from '../locales/ar/errors.json';
import arExpenses from '../locales/ar/expenses.json';
import arVouchers from '../locales/ar/vouchers.json';
import arFiles from '../locales/ar/files.json';
import arGl from '../locales/ar/gl.json';
import arHr from '../locales/ar/hr.json';
import arImagegen from '../locales/ar/imagegen.json';
import arFib from '../locales/ar/fib.json';
import arOtp from '../locales/ar/otp.json';
import arStocktake from '../locales/ar/stocktake.json';
import arCombos from '../locales/ar/combos.json';
import arManufacturing from '../locales/ar/manufacturing.json';
import arTreasury from '../locales/ar/treasury.json';
import arDelivery from '../locales/ar/delivery.json';
import arBatches from '../locales/ar/batches.json';
import arInstallments from '../locales/ar/installments.json';
import arInventory from '../locales/ar/inventory.json';
import arItems from '../locales/ar/items.json';
import arMandob from '../locales/ar/mandob.json';
import arParties from '../locales/ar/parties.json';
import arPermissions from '../locales/ar/permissions.json';
import arPlatform from '../locales/ar/platform.json';
import arPortal from '../locales/ar/portal.json';
import arPos from '../locales/ar/pos.json';
import arPricing from '../locales/ar/pricing.json';
import arPush from '../locales/ar/push.json';
import arReports from '../locales/ar/reports.json';
import arSettings from '../locales/ar/settings.json';
import arTelegram from '../locales/ar/telegram.json';
import arUsers from '../locales/ar/users.json';
import arWhatsapp from '../locales/ar/whatsapp.json';
import ckbAccounts from '../locales/ckb/accounts.json';
import ckbAi from '../locales/ckb/ai.json';
import ckbAiReports from '../locales/ckb/aiReports.json';
import ckbAudit from '../locales/ckb/audit.json';
import ckbAuth from '../locales/ckb/auth.json';
import ckbBatches from '../locales/ckb/batches.json';
import ckbBrand from '../locales/ckb/brand.json';
import ckbCashback from '../locales/ckb/cashback.json';
import ckbCms from '../locales/ckb/cms.json';
import ckbCombos from '../locales/ckb/combos.json';
import ckbCommon from '../locales/ckb/common.json';
import ckbCoupons from '../locales/ckb/coupons.json';
import ckbCrm from '../locales/ckb/crm.json';
import ckbCustomFields from '../locales/ckb/customFields.json';
import ckbDelivery from '../locales/ckb/delivery.json';
import ckbDiscounts from '../locales/ckb/discounts.json';
import ckbDocuments from '../locales/ckb/documents.json';
import ckbErrors from '../locales/ckb/errors.json';
import ckbExpenses from '../locales/ckb/expenses.json';
import ckbFib from '../locales/ckb/fib.json';
import ckbFiles from '../locales/ckb/files.json';
import ckbGl from '../locales/ckb/gl.json';
import ckbHr from '../locales/ckb/hr.json';
import ckbImagegen from '../locales/ckb/imagegen.json';
import ckbInstallments from '../locales/ckb/installments.json';
import ckbInventory from '../locales/ckb/inventory.json';
import ckbItems from '../locales/ckb/items.json';
import ckbMandob from '../locales/ckb/mandob.json';
import ckbManufacturing from '../locales/ckb/manufacturing.json';
import ckbOtp from '../locales/ckb/otp.json';
import ckbParties from '../locales/ckb/parties.json';
import ckbPermissions from '../locales/ckb/permissions.json';
import ckbPlatform from '../locales/ckb/platform.json';
import ckbPortal from '../locales/ckb/portal.json';
import ckbPos from '../locales/ckb/pos.json';
import ckbPricing from '../locales/ckb/pricing.json';
import ckbPush from '../locales/ckb/push.json';
import ckbReports from '../locales/ckb/reports.json';
import ckbSettings from '../locales/ckb/settings.json';
import ckbStocktake from '../locales/ckb/stocktake.json';
import ckbStories from '../locales/ckb/stories.json';
import ckbTelegram from '../locales/ckb/telegram.json';
import ckbTreasury from '../locales/ckb/treasury.json';
import ckbUsers from '../locales/ckb/users.json';
import ckbVouchers from '../locales/ckb/vouchers.json';
import ckbWhatsapp from '../locales/ckb/whatsapp.json';
import deAccounts from '../locales/de/accounts.json';
import deAi from '../locales/de/ai.json';
import deAiReports from '../locales/de/aiReports.json';
import deAudit from '../locales/de/audit.json';
import deAuth from '../locales/de/auth.json';
import deBatches from '../locales/de/batches.json';
import deBrand from '../locales/de/brand.json';
import deCashback from '../locales/de/cashback.json';
import deCms from '../locales/de/cms.json';
import deCombos from '../locales/de/combos.json';
import deCommon from '../locales/de/common.json';
import deCoupons from '../locales/de/coupons.json';
import deCrm from '../locales/de/crm.json';
import deCustomFields from '../locales/de/customFields.json';
import deDelivery from '../locales/de/delivery.json';
import deDiscounts from '../locales/de/discounts.json';
import deDocuments from '../locales/de/documents.json';
import deErrors from '../locales/de/errors.json';
import deExpenses from '../locales/de/expenses.json';
import deFib from '../locales/de/fib.json';
import deFiles from '../locales/de/files.json';
import deGl from '../locales/de/gl.json';
import deHr from '../locales/de/hr.json';
import deImagegen from '../locales/de/imagegen.json';
import deInstallments from '../locales/de/installments.json';
import deInventory from '../locales/de/inventory.json';
import deItems from '../locales/de/items.json';
import deMandob from '../locales/de/mandob.json';
import deManufacturing from '../locales/de/manufacturing.json';
import deOtp from '../locales/de/otp.json';
import deParties from '../locales/de/parties.json';
import dePermissions from '../locales/de/permissions.json';
import dePlatform from '../locales/de/platform.json';
import dePortal from '../locales/de/portal.json';
import dePos from '../locales/de/pos.json';
import dePricing from '../locales/de/pricing.json';
import dePush from '../locales/de/push.json';
import deReports from '../locales/de/reports.json';
import deSettings from '../locales/de/settings.json';
import deStocktake from '../locales/de/stocktake.json';
import deStories from '../locales/de/stories.json';
import deTelegram from '../locales/de/telegram.json';
import deTreasury from '../locales/de/treasury.json';
import deUsers from '../locales/de/users.json';
import deVouchers from '../locales/de/vouchers.json';
import deWhatsapp from '../locales/de/whatsapp.json';
import enAccounts from '../locales/en/accounts.json';
import enAi from '../locales/en/ai.json';
import enAiReports from '../locales/en/aiReports.json';
import enAudit from '../locales/en/audit.json';
import enAuth from '../locales/en/auth.json';
import enBrand from '../locales/en/brand.json';
import enCashback from '../locales/en/cashback.json';
import enCms from '../locales/en/cms.json';
import enStories from '../locales/en/stories.json';
import enCommon from '../locales/en/common.json';
import enCoupons from '../locales/en/coupons.json';
import enCrm from '../locales/en/crm.json';
import enDiscounts from '../locales/en/discounts.json';
import enCustomFields from '../locales/en/customFields.json';
import enDocuments from '../locales/en/documents.json';
import enErrors from '../locales/en/errors.json';
import enExpenses from '../locales/en/expenses.json';
import enVouchers from '../locales/en/vouchers.json';
import enFiles from '../locales/en/files.json';
import enGl from '../locales/en/gl.json';
import enHr from '../locales/en/hr.json';
import enImagegen from '../locales/en/imagegen.json';
import enFib from '../locales/en/fib.json';
import enOtp from '../locales/en/otp.json';
import enStocktake from '../locales/en/stocktake.json';
import enCombos from '../locales/en/combos.json';
import enManufacturing from '../locales/en/manufacturing.json';
import enTreasury from '../locales/en/treasury.json';
import enDelivery from '../locales/en/delivery.json';
import enBatches from '../locales/en/batches.json';
import enInstallments from '../locales/en/installments.json';
import enInventory from '../locales/en/inventory.json';
import enItems from '../locales/en/items.json';
import enMandob from '../locales/en/mandob.json';
import enParties from '../locales/en/parties.json';
import enPermissions from '../locales/en/permissions.json';
import enPlatform from '../locales/en/platform.json';
import enPortal from '../locales/en/portal.json';
import enPos from '../locales/en/pos.json';
import enPricing from '../locales/en/pricing.json';
import enPush from '../locales/en/push.json';
import enReports from '../locales/en/reports.json';
import enSettings from '../locales/en/settings.json';
import enTelegram from '../locales/en/telegram.json';
import enUsers from '../locales/en/users.json';
import enWhatsapp from '../locales/en/whatsapp.json';
import kmrAccounts from '../locales/kmr/accounts.json';
import kmrAi from '../locales/kmr/ai.json';
import kmrAiReports from '../locales/kmr/aiReports.json';
import kmrAudit from '../locales/kmr/audit.json';
import kmrAuth from '../locales/kmr/auth.json';
import kmrBatches from '../locales/kmr/batches.json';
import kmrBrand from '../locales/kmr/brand.json';
import kmrCashback from '../locales/kmr/cashback.json';
import kmrCms from '../locales/kmr/cms.json';
import kmrCombos from '../locales/kmr/combos.json';
import kmrCommon from '../locales/kmr/common.json';
import kmrCoupons from '../locales/kmr/coupons.json';
import kmrCrm from '../locales/kmr/crm.json';
import kmrCustomFields from '../locales/kmr/customFields.json';
import kmrDelivery from '../locales/kmr/delivery.json';
import kmrDiscounts from '../locales/kmr/discounts.json';
import kmrDocuments from '../locales/kmr/documents.json';
import kmrErrors from '../locales/kmr/errors.json';
import kmrExpenses from '../locales/kmr/expenses.json';
import kmrFib from '../locales/kmr/fib.json';
import kmrFiles from '../locales/kmr/files.json';
import kmrGl from '../locales/kmr/gl.json';
import kmrHr from '../locales/kmr/hr.json';
import kmrImagegen from '../locales/kmr/imagegen.json';
import kmrInstallments from '../locales/kmr/installments.json';
import kmrInventory from '../locales/kmr/inventory.json';
import kmrItems from '../locales/kmr/items.json';
import kmrMandob from '../locales/kmr/mandob.json';
import kmrManufacturing from '../locales/kmr/manufacturing.json';
import kmrOtp from '../locales/kmr/otp.json';
import kmrParties from '../locales/kmr/parties.json';
import kmrPermissions from '../locales/kmr/permissions.json';
import kmrPlatform from '../locales/kmr/platform.json';
import kmrPortal from '../locales/kmr/portal.json';
import kmrPos from '../locales/kmr/pos.json';
import kmrPricing from '../locales/kmr/pricing.json';
import kmrPush from '../locales/kmr/push.json';
import kmrReports from '../locales/kmr/reports.json';
import kmrSettings from '../locales/kmr/settings.json';
import kmrStocktake from '../locales/kmr/stocktake.json';
import kmrStories from '../locales/kmr/stories.json';
import kmrTelegram from '../locales/kmr/telegram.json';
import kmrTreasury from '../locales/kmr/treasury.json';
import kmrUsers from '../locales/kmr/users.json';
import kmrVouchers from '../locales/kmr/vouchers.json';
import kmrWhatsapp from '../locales/kmr/whatsapp.json';

/**
 * i18next bootstrap. Namespaces:
 *   common, auth, settings, users, audit, errors, brand, accounts
 *
 * The "brand" namespace is seeded at build time by the Vite plugin in
 * apps/web/vite.config.ts from /brand/brand.config.json — do NOT hand-edit
 * src/locales/{en,ar}/brand.json.
 */
const NS = [
  'common', 'auth', 'settings', 'users', 'audit', 'errors', 'brand',
  'accounts', 'items', 'parties', 'inventory', 'gl', 'documents', 'reports',
  'ai', 'imagegen', 'fib', 'otp', 'stocktake', 'manufacturing', 'combos', 'treasury', 'delivery', 'batches', 'hr', 'crm', 'customFields', 'installments', 'expenses', 'vouchers', 'platform', 'pos', 'pricing', 'coupons', 'discounts',
  'portal', 'cms', 'files', 'cashback', 'mandob', 'telegram', 'push', 'whatsapp', 'stories', 'aiReports',
  'permissions',
] as const;

export async function initI18n(): Promise<void> {
  await i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: {
        en: {
          common: enCommon,
          auth: enAuth,
          settings: enSettings,
          users: enUsers,
          audit: enAudit,
          errors: enErrors,
          brand: enBrand,
          accounts: enAccounts,
          items: enItems,
          parties: enParties,
          inventory: enInventory,
          gl: enGl,
          documents: enDocuments,
          reports: enReports,
          ai: enAi,
          aiReports: enAiReports,
          imagegen: enImagegen,
          fib: enFib,
          otp: enOtp,
          stocktake: enStocktake,
          manufacturing: enManufacturing,
          combos: enCombos,
          treasury: enTreasury,
          delivery: enDelivery,
          batches: enBatches,
          hr: enHr,
          crm: enCrm,
          customFields: enCustomFields,
          installments: enInstallments,
          expenses: enExpenses,
          vouchers: enVouchers,
          platform: enPlatform,
          permissions: enPermissions,
          pos: enPos,
          pricing: enPricing,
          coupons: enCoupons,
          discounts: enDiscounts,
          portal: enPortal,
          cms: enCms,
          stories: enStories,
          files: enFiles,
          cashback: enCashback,
          mandob: enMandob,
          telegram: enTelegram,
          push: enPush,
          whatsapp: enWhatsapp,
        },
        ar: {
          common: arCommon,
          auth: arAuth,
          settings: arSettings,
          users: arUsers,
          audit: arAudit,
          errors: arErrors,
          brand: arBrand,
          accounts: arAccounts,
          items: arItems,
          parties: arParties,
          inventory: arInventory,
          gl: arGl,
          documents: arDocuments,
          reports: arReports,
          ai: arAi,
          aiReports: arAiReports,
          imagegen: arImagegen,
          fib: arFib,
          otp: arOtp,
          stocktake: arStocktake,
          manufacturing: arManufacturing,
          combos: arCombos,
          treasury: arTreasury,
          delivery: arDelivery,
          batches: arBatches,
          hr: arHr,
          crm: arCrm,
          customFields: arCustomFields,
          installments: arInstallments,
          expenses: arExpenses,
          vouchers: arVouchers,
          platform: arPlatform,
          permissions: arPermissions,
          pos: arPos,
          pricing: arPricing,
          coupons: arCoupons,
          discounts: arDiscounts,
          portal: arPortal,
          cms: arCms,
          stories: arStories,
          files: arFiles,
          cashback: arCashback,
          mandob: arMandob,
          telegram: arTelegram,
          push: arPush,
          whatsapp: arWhatsapp,
        },
        ckb: {
          common: ckbCommon,
          auth: ckbAuth,
          settings: ckbSettings,
          users: ckbUsers,
          audit: ckbAudit,
          errors: ckbErrors,
          brand: ckbBrand,
          accounts: ckbAccounts,
          items: ckbItems,
          parties: ckbParties,
          inventory: ckbInventory,
          gl: ckbGl,
          documents: ckbDocuments,
          reports: ckbReports,
          ai: ckbAi,
          aiReports: ckbAiReports,
          imagegen: ckbImagegen,
          fib: ckbFib,
          otp: ckbOtp,
          stocktake: ckbStocktake,
          manufacturing: ckbManufacturing,
          combos: ckbCombos,
          treasury: ckbTreasury,
          delivery: ckbDelivery,
          batches: ckbBatches,
          hr: ckbHr,
          crm: ckbCrm,
          customFields: ckbCustomFields,
          installments: ckbInstallments,
          expenses: ckbExpenses,
          vouchers: ckbVouchers,
          platform: ckbPlatform,
          permissions: ckbPermissions,
          pos: ckbPos,
          pricing: ckbPricing,
          coupons: ckbCoupons,
          discounts: ckbDiscounts,
          portal: ckbPortal,
          cms: ckbCms,
          stories: ckbStories,
          files: ckbFiles,
          cashback: ckbCashback,
          mandob: ckbMandob,
          telegram: ckbTelegram,
          push: ckbPush,
          whatsapp: ckbWhatsapp,
        },
        kmr: {
          common: kmrCommon,
          auth: kmrAuth,
          settings: kmrSettings,
          users: kmrUsers,
          audit: kmrAudit,
          errors: kmrErrors,
          brand: kmrBrand,
          accounts: kmrAccounts,
          items: kmrItems,
          parties: kmrParties,
          inventory: kmrInventory,
          gl: kmrGl,
          documents: kmrDocuments,
          reports: kmrReports,
          ai: kmrAi,
          aiReports: kmrAiReports,
          imagegen: kmrImagegen,
          fib: kmrFib,
          otp: kmrOtp,
          stocktake: kmrStocktake,
          manufacturing: kmrManufacturing,
          combos: kmrCombos,
          treasury: kmrTreasury,
          delivery: kmrDelivery,
          batches: kmrBatches,
          hr: kmrHr,
          crm: kmrCrm,
          customFields: kmrCustomFields,
          installments: kmrInstallments,
          expenses: kmrExpenses,
          vouchers: kmrVouchers,
          platform: kmrPlatform,
          permissions: kmrPermissions,
          pos: kmrPos,
          pricing: kmrPricing,
          coupons: kmrCoupons,
          discounts: kmrDiscounts,
          portal: kmrPortal,
          cms: kmrCms,
          stories: kmrStories,
          files: kmrFiles,
          cashback: kmrCashback,
          mandob: kmrMandob,
          telegram: kmrTelegram,
          push: kmrPush,
          whatsapp: kmrWhatsapp,
        },
        de: {
          common: deCommon,
          auth: deAuth,
          settings: deSettings,
          users: deUsers,
          audit: deAudit,
          errors: deErrors,
          brand: deBrand,
          accounts: deAccounts,
          items: deItems,
          parties: deParties,
          inventory: deInventory,
          gl: deGl,
          documents: deDocuments,
          reports: deReports,
          ai: deAi,
          aiReports: deAiReports,
          imagegen: deImagegen,
          fib: deFib,
          otp: deOtp,
          stocktake: deStocktake,
          manufacturing: deManufacturing,
          combos: deCombos,
          treasury: deTreasury,
          delivery: deDelivery,
          batches: deBatches,
          hr: deHr,
          crm: deCrm,
          customFields: deCustomFields,
          installments: deInstallments,
          expenses: deExpenses,
          vouchers: deVouchers,
          platform: dePlatform,
          permissions: dePermissions,
          pos: dePos,
          pricing: dePricing,
          coupons: deCoupons,
          discounts: deDiscounts,
          portal: dePortal,
          cms: deCms,
          stories: deStories,
          files: deFiles,
          cashback: deCashback,
          mandob: deMandob,
          telegram: deTelegram,
          push: dePush,
          whatsapp: deWhatsapp,
        },
      },
      ns: NS as unknown as string[],
      defaultNS: 'common',
      fallbackLng: 'en',
      // Allow any enabled content language (e.g. fr, ckb); chrome strings fall
      // back to English for languages without a bundled UI catalog.
      supportedLngs: false,
      interpolation: { escapeValue: false },
      detection: {
        order: ['querystring', 'cookie', 'navigator', 'htmlTag'],
        caches: ['cookie'],
        lookupCookie: 'erp_locale',
        lookupQuerystring: 'lng',
      },
      saveMissing: import.meta.env.DEV,
      missingKeyHandler: (_lngs, ns, key) => {
        if (import.meta.env.DEV) {
           
          console.warn(`[i18n] missing key: ${ns}:${key}`);
        }
      },
    });
}

export function currentLocale(): Locale {
  const code = i18n.language.split('-')[0] ?? 'en';
  return (LOCALES as readonly string[]).includes(code) ? (code as Locale) : 'en';
}

export { i18n };
